// extracted by mini-css-extract-plugin
export default {"BasicButton":"BasicButton_BasicButton__aKSlz","Red":"BasicButton_Red__sgSHh","Gray":"BasicButton_Gray__io4Qp","DarkGreen":"BasicButton_DarkGreen__HbvkL"};